import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faSpinner } from '@fortawesome/free-solid-svg-icons';

const ReportHeader = ({ onExportPdf, isExporting, isLoading, totalRegistros }) => {
    return (
        <div className="d-flex align-items-center justify-content-end w-100 mb-3">
            {/* Botón de exportar PDF */}
            <div>
                <button
                    type="button"
                    className="btn btn-danger d-inline-flex align-items-center gap-1 gap-md-2 px-2 px-md-3 py-1 py-md-2 shadow-none fw-semibold"
                    onClick={onExportPdf}
                    disabled={isExporting || isLoading || totalRegistros === 0}
                    style={{
                        borderRadius: '8px',
                        whiteSpace: 'nowrap'
                    }}
                >
                    <FontAwesomeIcon
                        icon={isExporting ? faSpinner : faFilePdf}
                        spin={isExporting}
                    />
                    {/* Texto en móvil */}
                    <span className="d-inline d-md-none" style={{ fontSize: '0.75rem' }}>
                        {isExporting ? 'PDF...' : 'Exportar PDF'}
                    </span>
                    {/* Texto en escritorio */}
                    <span className="d-none d-md-inline">
                        {isExporting ? 'Generando PDF...' : 'Exportar PDF'}
                    </span>
                </button>
            </div>
        </div>
    );
};

export default ReportHeader;